// FavoritoItem.tsx
import React from 'react';

// Definindo as interfaces para os tipos de dados
interface Registro {
  descricao: string;
  multiplicador: number;
}

interface Favorito {
  id?: number;
  nome: string;
  registros: Registro[];
}

interface FavoritoItemProps {
  favorito: Favorito;
  onDelete: (id: number) => void;
}

const FavoritoItem: React.FC<FavoritoItemProps> = ({ favorito, onDelete }) => {
    const somaMultiplicadores = favorito.registros.reduce(
        (total, registro) => total + registro.multiplicador,
        0
    );
   return (
    <li className="border p-4 rounded-lg text-gray-700 bg-yellow-100 transition-all duration-300 ease-in-out hover:shadow-lg">
      <strong>{favorito.nome}</strong>
      <ul>
        {favorito.registros.map((registro, idx) => (
          <li key={idx}>
            {registro.descricao} {registro.multiplicador}
          </li>
        ))}
        <p><strong>Soma dos multiplicadores: </strong>{somaMultiplicadores}</p>
      </ul>
      <button
        onClick={() => onDelete(favorito.id ?? 0)} // Chama a função para deletar o favorito
        className="mt-2 bg-red-500 text-white px-4 py-2 rounded hover:bg-red-600"
      >
        Excluir
      </button>
    </li>
  );
};

export default FavoritoItem;
